import { AfterViewInit, Component, viewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { InputText, InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-formly-auto-complete',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AutoComplete, FormlyModule],
  template: `
    <div class="field">
      <label [for]="field.key" class="block mb-2" *ngIf="to.label">
        {{ to.label }}
        <span *ngIf="to.required" class="text-red-500">*</span>
      </label>
      <p-autocomplete
        #autoCompleteObj
        [forceSelection]="true"
        [suggestions]="to.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="'displayLabel'"
        [dropdown]="false"
        [minLength]="1"
        [delay]="300"
        [style]="{ width: '100%' }"
        (onSelect)="to.onSelect($event)"
        (completeMethod)="to.searchObject(to, $event, field)"
        placeholder="Keresés termékkód vagy név alapján... (min. 2 karakter)">
        
        <!-- Payroll mintájára egyszerű template -->
        <ng-template let-hardware pTemplate="item">
          <div class="flex justify-between align-items-center">
            <div>
              <div class="font-medium">{{ hardware.displayLabel }}</div>
              <small class="text-gray-500" *ngIf="hardware.storageInfo">
                {{ hardware.storageInfo }}
              </small>
            </div>
            <span 
              *ngIf="hardware.amount !== undefined && hardware.amount !== null"
              class="text-sm px-2 py-1 rounded"
              [class.bg-green-100]="hardware.amount > 0"
              [class.bg-red-100]="hardware.amount === 0"
              [class.text-green-800]="hardware.amount > 0"
              [class.text-red-800]="hardware.amount === 0">
              {{ hardware.amount > 0 ? hardware.amount + ' db' : 'Nincs készlet' }}
            </span>
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
  `,
})
export class FormlyProductAutoCompleteComponent
  extends FieldType<FieldTypeConfig> {
  readonly autoComplete = viewChild<AutoComplete>('autoCompleteObj');
}